import React from "react";
import styled from "styled-components";
import { Chip, ChipProps, TableCell } from "@material-ui/core";

export const ChipContainer = styled.div`
    & > * {
        margin: ${({ theme }) => `${theme.spacing(0.5)}px`};
    }
`;

export const ChipTableCell = styled(TableCell)`
    & > * {
        margin: ${({ theme }) => `${theme.spacing(0.5)}px`};
    }
`;

export const CustomChip = styled(
    ({ bgColor, minWidth, ...props }: ChipProps & { bgColor?: string; minWidth?: number }) => <Chip {...props} />
)`
    height: 18px;
    //color: ${({ theme }) => theme.palette.grey[600]};
    border-radius: ${({ theme }) => theme.spacing(0.5)}px;
    background-color: ${({ bgColor = "transparent" }) => bgColor};
    min-width: ${({ minWidth = 0 }) => minWidth}px;
`;
